import logo from './logo.svg';
import './App.css';
import React, { Component }  from 'react';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        Deployment is happening here
      </header>
    </div>
  );
}

export default App;
